import React from 'react';
import { LayoutGrid, LayoutDashboard, Users, CreditCard, BarChart, Settings, HelpCircle, LogOut, Search, Bell, User, Database } from 'lucide-react';
import { useNavigate, Outlet, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/auth/AuthProvider';
import { Dropdown, MenuProps } from 'antd';

const AdminLayout: React.FC = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const menuItems: MenuProps['items'] = [
        {
            key: 'perfil',
            label: 'Meu Perfil',
            icon: <User className="size-4" />,
            onClick: () => navigate('/dashboard-admin/perfil'),
        },
        {
            key: 'configuracoes',
            label: 'Configurações',
            icon: <Settings className="size-4" />,
            onClick: () => navigate('/dashboard-admin/configuracoes'),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Sair',
            icon: <LogOut className="size-4" />,
            danger: true,
            onClick: () => {
                logout();
                navigate('/login');
            },
        },
    ];

    return (
        <div className="flex min-h-screen font-sans bg-[#F8F9FA] dark:bg-[#1F2937] text-[#374151] dark:text-[#E5E7EB]">
            {/* SideNavBar */}
            <aside className="flex w-64 flex-col bg-white dark:bg-[#111827] border-r border-[#E5E7EB] dark:border-[#374151]">
                <div className="flex h-full flex-col justify-between p-4">
                    <div className="flex flex-col gap-6">
                        <div className="flex items-center gap-3 px-2">
                            <div className="flex items-center justify-center size-10 bg-[#2563EB]/20 rounded-lg text-[#2563EB]">
                                <LayoutGrid className="size-6" />
                            </div>
                            <div className="flex flex-col">
                                <h1 className="text-[#374151] dark:text-[#E5E7EB] text-base font-bold leading-normal">Quantto App</h1>
                                <p className="text-[#6B7280] dark:text-[#9CA3AF] text-sm font-normal leading-normal">Painel Admin</p>
                            </div>
                        </div>
                        <nav className="flex flex-col gap-2">
                            <Link to="/dashboard-admin" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                                <LayoutDashboard className="size-5" />
                                <p className="text-sm font-medium leading-normal">Dashboard</p>
                            </Link>
                            <Link to="/dashboard-admin/usuarios" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                                <Users className="size-5" />
                                <p className="text-sm font-medium leading-normal">Usuários</p>
                            </Link>
                            <Link to="/dashboard-admin/planos" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                                <CreditCard className="size-5" />
                                <p className="text-sm font-medium leading-normal">Planos</p>
                            </Link>
                            <Link to="/dashboard-admin/relatorios" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                                <BarChart className="size-5" />
                                <p className="text-sm font-medium leading-normal">Relatórios</p>
                            </Link>
                            <Link to="/dashboard-admin/sinapi" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                                <Database className="size-5" />
                                <p className="text-sm font-medium leading-normal">SINAPI</p>
                            </Link>
                            <Link to="/dashboard-admin/configuracoes" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                                <Settings className="size-5" />
                                <p className="text-sm font-medium leading-normal">Configurações</p>
                            </Link>
                        </nav>
                    </div>
                    <div className="flex flex-col gap-1">
                        <Link to="/dashboard-admin/ajuda" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                            <HelpCircle className="size-5" />
                            <p className="text-sm font-medium leading-normal">Ajuda</p>
                        </Link>
                        <button onClick={() => { logout(); navigate('/login'); }} className="flex w-full items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                            <LogOut className="size-5" />
                            <p className="text-sm font-medium leading-normal">Logout</p>
                        </button>
                    </div>
                </div>
            </aside>
            <main className="flex-1">
                {/* TopNavBar */}
                <header className="flex items-center justify-between whitespace-nowrap border-b border-[#E5E7EB] dark:border-[#374151] px-6 py-4 bg-white dark:bg-[#111827] sticky top-0 z-10">
                    <div className="flex items-center gap-8">
                        <label className="relative flex items-center min-w-40 max-w-64">
                            <Search className="absolute left-3 text-[#6B7280] dark:text-[#9CA3AF] size-5" />
                            <input className="flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#374151] dark:text-[#E5E7EB] bg-[#F8F9FA] dark:bg-[#1F2937] focus:outline-none focus:ring-2 focus:ring-[#2563EB] border-transparent h-10 placeholder:text-[#6B7280] dark:placeholder:text-[#9CA3AF] pl-10 pr-4 text-sm font-normal" placeholder="Busca global..." />
                        </label>
                    </div>
                    <div className="flex flex-1 justify-end items-center gap-4">
                        <button className="flex cursor-pointer items-center justify-center rounded-full h-10 w-10 text-[#6B7280] dark:text-[#9CA3AF] hover:bg-black/5 dark:hover:bg-white/5 hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                            <Bell className="size-5" />
                        </button>
                        <Dropdown menu={{ items: menuItems }} placement="bottomRight" arrow>
                            <div className="cursor-pointer bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10 ring-2 ring-offset-2 ring-offset-white dark:ring-offset-[#111827] ring-[#2563EB]/50" style={{ backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuBx_ow8nDGs8AvMP7vzfbeuGaLwD1uHq7wxWRjq5GniMD1AVQLZRmFSrF3EA4jdhHjvXIOk6yNcrYxZgjbHVwm9oXLpJ03r-XubsYFzbr1cgo_sXw_95VIvONi_p-6L5f_dGXkajWaYyOJEROlzFJWzVHBn5OXj8OG5__pTF1Z1GB6SUxYbt8KJ91VsmusInwIiuWdIXrAsCQ0mv3g5WovHqYfaXoD0V4fYqoh3RhCIILf68TLhU6KgZY-PVj6stAl-XbRAE9csiyM")' }}></div>
                        </Dropdown>
                    </div>
                </header>
                {/* Main Content */}
                <div className="p-6 space-y-6">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
